/**
 * Front-end JavaScript
 *
 * The JavaScript code you place here will be processed by esbuild. The output
 * file will be created at `../theme/js/script.min.js` and enqueued in
 * `../theme/functions.php`.
 *
 * For esbuild documentation, please see:
 * https://esbuild.github.io/
 */
import './modules/avif-webp';
import signature from '@xenolito/console-signature';
import { OverlayScrollbars } from 'overlayscrollbars';
import './modules/contactForm7';
import './modules/desktopMenuNav';
import './modules/mobileMenuNav';
import './modules/animation_blocks';
import './modules/swiper-logos';
import './modules/swiper-backgrounds';
import './modules/swiper-cards';
import './modules/counter_animation';
import './modules/faqs';

document.addEventListener('DOMContentLoaded', () => {
	signature();
	setScrollBars();
	animateHeaderOnScroll();
	setBackgrounds();
	// customDimension();
});

const setScrollBars = () => {
	OverlayScrollbars(document.querySelector('body'), {
		paddingAbsolute: false,
		showNativeOverlaidScrollbars: false,
		scrollbars: {
			theme: 'os-theme-dark',
			visibility: 'auto',
			autoHide: 'always',
			autoHideDelay: 1300,
			autoHideSuspend: false,
			dragScroll: true,
			clickScroll: false,
			pointers: ['mouse', 'touch', 'pen'],
		},
		overflow: {
			x: 'hidden',
			y: 'scroll',
		},
	});
};

const animateHeaderOnScroll = () => {
	// const content = document.querySelector('#content'); // container to add element to observe that will trigger target class modification
	const body = document.querySelector('body');
	let content = document.querySelector('#content .entry-content');

	if (!content) return;

	const hasSlider = document.querySelector('#content .entry-content .slider');

	if (hasSlider) content = hasSlider;

	const header = document.querySelector('header.site-header'); // target element to modify classes
	// add element as trigger target to observe
	const triggerEl = document.createElement('div');
	triggerEl.setAttribute('class', 'sticky-header-trigger');
	triggerEl.style.pointerEvents = 'none';
	hasSlider ? content.append(triggerEl) : content.prepend(triggerEl);

	const targetToObserve = document.querySelector('.sticky-header-trigger');

	if (!targetToObserve) return;

	const getTargetToObservePosY = (elementTarget) => {
		return elementTarget.offsetTop - window.scrollY;
	};

	const setHeaderScrolledStatus = (status) => {
		if (status) {
			header.classList.add('scrolledHeader');
			body.classList.add('scrolledHeader');
		} else {
			header.classList.remove('scrolledHeader');
			body.classList.remove('scrolledHeader');
		}
	};

	// if reload page already scrolled, then mark header as scrolled
	if (getTargetToObservePosY(targetToObserve) < header.offsetHeight) {
		setHeaderScrolledStatus(true);
	}

	const observerOptions = {
		root: null,
		rootMargin: `-${header.offsetHeight}px 0px 0px 0px`,
		threshold: 0,
	};

	const observerCallBack = (entries) => {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				// Only takes effect if not intersecting going out on top, if !inIntersecting below window height we considering not out for scrolledHeader.
				if (
					getTargetToObservePosY(targetToObserve) < window.innerHeight
				) {
					setHeaderScrolledStatus(true);
				}
			} else {
				setHeaderScrolledStatus(false);
			}
		});
	};

	const observer = new IntersectionObserver(
		observerCallBack,
		observerOptions
	); // eslint-disable-line
	observer.observe(targetToObserve);
};

const setBackgrounds = () => {
	const elemBg = document.querySelectorAll('.has-bg');
	if (!elemBg.length) return;

	elemBg.forEach((el) => {
		const bg = el.querySelector('.is-bg img');
		if (!bg) return;

		const isFixed = el.classList.contains('bg-fixed');
		const bgSrc = bg.getAttribute('src');

		el.style.backgroundImage = `url(${bgSrc})`;
		el.style.backgroundSize = 'cover';
		el.style.backgroundPosition = 'center';
		if (isFixed) {
			// This won't work on many mobile devides, including iOS...
			el.style.backgroundAttachment = 'fixed';
		}
	});
};

const customDimension = () => {
	const elem = document.querySelectorAll('[data-dim]');
	if (!elem.length) return;
	elem.forEach((el) => {
		target = el.querySelector('img,svg');
		if (!target) return;
		target.style.height = `${el.dataset.dim}px`;
	});
};
